import { createIcon } from './create-icon';

/** Two opposed arrows — one thing traded for another. */
export const SwapIcon = createIcon(
  'SwapIcon',
  <>
    <path d="M7 4v13M3 13l4 4 4-4" />
    <path d="M17 20V7M13 11l4-4 4 4" />
  </>,
);
